import { render, staticRenderFns } from "./CurrentEvents.vue?vue&type=template&id=08f0f1fe&"
import script from "./CurrentEvents.vue?vue&type=script&lang=js&"
export * from "./CurrentEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports